import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
/** Convert a snake_case slice type to a human-readable Title Case label */
export const sliceLabel = (sliceType: string): string =>
  sliceType
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ")

export const getBaseUrl = () => {
  if (process.env.NEXT_PUBLIC_SITE_URL) {
    return process.env.NEXT_PUBLIC_SITE_URL.replace(/\/$/, "")
  }
  if (process.env.NEXT_PUBLIC_VERCEL_ENV === "production") {
    const url =
      process.env.NEXT_PUBLIC_VERCEL_PRODUCTION_URL ??
      process.env.NEXT_PUBLIC_VERCEL_URL
    if (url) return `https://${url}`
  }
  if (
    process.env.NEXT_PUBLIC_VERCEL_ENV === "preview" &&
    process.env.NEXT_PUBLIC_VERCEL_URL
  ) {
    return `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`
  }
  return "http://localhost:3000"
}
